import { render, staticRenderFns } from "./DisbursementPendingDocumentSection.vue?vue&type=template&id=04cf4151&scoped=true&"
import script from "./DisbursementPendingDocumentSection.vue?vue&type=script&lang=js&"
export * from "./DisbursementPendingDocumentSection.vue?vue&type=script&lang=js&"
import style0 from "./DisbursementPendingDocumentSection.vue?vue&type=style&index=0&id=04cf4151&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf4151",
  null
  
)

export default component.exports